module.exports = __webpack_public_path__ + "img/nodeType3.c3902ffd.svg";